<script lang="ts">
    import {cart} from "../../services/cart-service";
    export let orderSubmitting: boolean;
</script>

<button
        type="button"
        class="btn btn-danger"
        title="clear cart"
        disabled={orderSubmitting}
        on:click={cart.clear}
>
    <span class="fa fa-close mr-1"></span>
    <i class="bi bi-x-circle"></i>
    Clear Cart
</button>
